module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dashboard-widget', {
    attrs: {
      "is-loading-spinner": false,
      "is-loading": _vm.isLoading
    }
  }, [
    [_c('div', {
      staticClass: "row gutter-sm"
    }, [_c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1 icon"
    }, [_c('img', {
      staticClass: "align-center",
      attrs: {
        "src": require("../../../../../assets/leads-count-blue-icon.svg")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 col-sm-10 col-md-10 col-lg-2"
    }, [_c('h2', [_vm._v(_vm._s(_vm.leads))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.leads_collected_label')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "colors": ['#BF0711', '#3a3e50'],
        "values": _vm.charts.hot.absolute === 0 ? [0, 100] : [_vm.charts.hot.relative, 100 - 100 * (_vm.charts.hot.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.hot.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.hot')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.hot.relative),
        "colors": ['#9C6F19', '#3a3e50'],
        "values": _vm.charts.warm.absolute === 0 ? [0, 100] : [_vm.charts.warm.relative, 100 - 100 * (_vm.charts.warm.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.warm.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.warm')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.warm.relative + _vm.charts.hot.relative),
        "colors": ['#00828E', '#3a3e50'],
        "values": _vm.charts.cold.absolute === 0 ? [0, 100] : [_vm.charts.cold.relative, 100 - 100 * (_vm.charts.cold.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.cold.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.cold')))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 col-sm-2 col-md-2 col-lg-1"
    }, [(_vm.isCharts) ? _c('pie-chart', {
      attrs: {
        "rotation": _vm.percentageToDegrees(_vm.charts.warm.relative + _vm.charts.hot.relative + _vm.charts.cold.relative),
        "colors": ['#9198AB', '#3a3e50'],
        "values": _vm.charts.unclassified.absolute === 0 ? [0, 100] : [_vm.charts.unclassified.relative, 100 - 100 * (_vm.charts.unclassified.absolute / _vm.leads)],
        "labels": ['Residential', 'Non-Residential']
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-1"
    }, [_c('h4', [_vm._v(_vm._s(_vm.charts.unclassified.absolute))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.dashboard.unclassified')))])])])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ad6520","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/widgets/LeadsCollectedWidget.vue
// module id = 1797
// module chunks = 0